import React, { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import "./Layout.css";
import styled, { createGlobalStyle, css, ThemeProvider } from "styled-components";
import { defaultTheme } from "../../theme";
import { AiFillInstagram } from "react-icons/ai";
import { MdMail } from "react-icons/md";
import AboutKinga from "./AboutKinga";
import linkResolver from "../utils/linkResolver";
import FeaturedPosts from "./FeaturedPosts";
import Contact from "./Contact";


const Header = styled.header`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
`;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${props => props.theme.colors.background};
  }

  a {
    text-decoration: none;
    color: unset;

  }

  //TODO typography sizing
  @media only screen and (max-width: 600px) {

  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {

  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {

  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {

  }
`;

const WidthLimiter = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
`;

const FooterWrapper = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: white;
  background-color: ${props => props.theme.colors.primary};
`;

const Icons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin: 10px;

    &:hover {
      color: ${props => props.theme.colors.accent} !important;
      cursor: pointer;
    }
  }
`;

const MenuWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.primary};
  //border-top: solid 1px darkgray;
  //border-bottom: solid 1px darkgray;
  color: white;
  height: 50px;
  display: flex;
  align-items: center;
  z-index: 9;

  padding: 0 50px;

`;

const Menu = styled.div`

  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  max-width: 1000px;


  a {
    padding: 10px;
    transition: color 0.2s;
    margin: 0 5px;
  }

  a:hover {
    color: ${props => props.theme.colors.secondary};
      // background-color: ${props => props.theme.colors.secondary};
  !important;

  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }

`;

const MainBody = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`;


const MenuToggle = styled.div<{ open: boolean }>`

  //z-index: 9999;
  width: 30px;
  height: 30px;
  transform: rotate(0deg);
  transition: all 0.25s ease-in;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;

  span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background-color: ${props => props.theme.colors.secondary};
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: ${(props) =>
            props.open ? "all 0.25s ease-in" : "all 0.25s ease-out"};
  }

  span:nth-child(1) {
    top: ${(props) => (props.open ? "calc(50% - 2px)" : "10%")};
    transform-origin: left center;
  }

  span:nth-child(2) {
    top: ${(props) => (props.open ? 0 : "calc(50% - 2px)")};
    left: ${(props) => (props.open ? "calc(50% - 2px)" : null)};
    width: ${(props) => (props.open ? "4px" : null)};
    height: ${(props) => (props.open ? "100%" : null)};
    transform-origin: left center;
  }

  span:nth-child(3) {
    top: calc(90% - 4px);
    transform-origin: left center;
    width: ${(props) => (props.open ? 0 : null)};
    opacity: ${(props) => (props.open ? 0 : 1)};
  }


  @media only screen and (min-width: 1201px) {
    display: none;
  }

`;

const RotateContainer = styled.div<{ open: boolean }>`
  height: 100%;
  width: 100%;
  transition: ${(props) => props.open ? "all 0.25s ease-in-out" : "all 0.25s ease-in-out"};
  transform: ${(props) => (props.open ? "rotate(-45deg)" : "none")};
`;

const MobileMenuWrapper = styled.div<{ open: boolean }>`
  position: fixed;
  overflow: hidden;
  top: ${(props) => (props.open ? "0" : "-100%")};
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  transition: ${(props) =>
          props.open ? "all 0.2s ease-out" : "all 0.2s ease-out"};
  background-color: ${props => props.theme.colors.primary};
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;

  padding-top: 55px;
  padding-bottom: 50px;

  a {
    font-size: x-large;
    color: white;
  }
  
  div:first-child {
    margin-right: 50px;
  }
`;

const Logo = styled.div`
  position: absolute;
  font-family: "sofia";
`;

const LogoLink = styled(Link)`
  position: absolute;
  font-family: "sofia";
  font-size: xx-large;

`;


const LogoHead = styled.div`
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Layout: React.FunctionComponent = ({ children }) => {
    const data = useStaticQuery<GatsbyTypes.LayoutComponentQuery>(graphql`
        query LayoutComponent {
            prismic {
                allCategorys {
                    edges {
                        node {
                            name
                            _meta {
                                id
                                uid
                                type
                            }
                        }
                    }
                }
            }
        }
    `);

    const [open, setOpen] = useState(false);

    const toggleMenu = () => {
        setOpen(!open);
    };


    return (
        <ThemeProvider theme={defaultTheme}>
            <GlobalStyle theme={defaultTheme} />
            <LogoHead>
                <LogoLink to={"/"}>
                    <span>
                                            Rybarczyk Kinga

                    </span>
                </LogoLink>
            </LogoHead>
            <Header>

                <MenuWrapper>

                    <Menu>
                        {data.prismic.allCategorys.edges && data.prismic.allCategorys.edges.map((category) => {
                                if (category) {
                                    return <Link key={category.node._meta.uid} activeStyle={{
                                        color: defaultTheme.colors.secondary
                                    }} to={linkResolver(category.node._meta)}>{category.node.name}</Link>;
                                }
                            }
                        )}
                    </Menu>
                    <MenuToggle onClick={() => setOpen(true)} open={false}>
                        <RotateContainer open={false}>
                            <span />
                            <span />
                            <span />
                        </RotateContainer>
                    </MenuToggle>

                </MenuWrapper>
                <MobileMenuWrapper open={open}>
                    <MenuToggle onClick={() => setOpen(false)} open={true}>
                        <RotateContainer open={true}>
                            <span />
                            <span />
                            <span />
                        </RotateContainer>
                    </MenuToggle>
                    {data.prismic.allCategorys.edges && data.prismic.allCategorys.edges.map((category) => {
                            if (category) {
                                return <Link key={category.node._meta.uid} activeStyle={{
                                    color: defaultTheme.colors.secondary
                                }} to={linkResolver(category.node._meta)}>{category.node.name}</Link>;
                            }
                        }
                    )}
                </MobileMenuWrapper>
            </Header>
            <WidthLimiter>
                <MainBody>
                    {children}
                    <div>
                        <AboutKinga />
                        <Contact />
                        <FeaturedPosts />
                    </div>
                </MainBody>
            </WidthLimiter>
            <footer
                style={{
                    marginTop: `2rem`
                }}
            >
                <FooterWrapper>
                    <span>© {new Date().getFullYear()}, Kinga Rybarczyk</span>
                    <Icons>
                        <a href="https://instagram.com/kinga.rybarczyk">
                            <AiFillInstagram size={30} color={defaultTheme.colors.secondary} />
                        </a>
                        <a href="mailto: rybarczykinga@gmail.com">
                            <MdMail size={32} color={defaultTheme.colors.secondary} />
                        </a>
                    </Icons>
                </FooterWrapper>
            </footer>
        </ThemeProvider>
    )
        ;
};

export default Layout;
